/* eslint-disable dot-notation */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '../../Services/API';

export const LoadSkuRequest = createAsyncThunk('sku/load', async (data, { rejectWithValue }) => {
  const params = {
    company_id: data.companyId || process.env.REACT_APP_COMP_EMM,
    $filter: data.filter,
    $count: true,
    $skip: (data.currentPage - 1) * data.pageSize,
    $top: data.pageSize
  };
  if (isNaN(params.$skip) || params.$skip < 0) {
    delete params.$skip;
  }
  try {
    const res = await API().get('/erp-skus', { params });
    return {
      list: res.data.value,
      count: res.data['@odata.count'],
      type: data.type
    };
  } catch (error) {
    console.log('LoadSkuRequest error ', error);
    return rejectWithValue(error.response.data);
  }
});

const initialState = {
  list: [],
  count: 0
};

const skuSlice = createSlice({
  name: 'sku',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(LoadSkuRequest.pending, (state) => {
      state.list = [];
      state.count = 0;
    });
    builder.addCase(LoadSkuRequest.fulfilled, (state, { payload }) => {
      state.list = payload.list;
      state.count = payload.count;
    });
    builder.addCase('auth/logout', () => {
      return initialState;
    });
  }
});

export default skuSlice.reducer;
export const skuActions = skuSlice.actions;
